import { ReviewReportsPageComponent } from "./review-reports-page.component";
import { ReviewReportsActionsModalComponent } from "./reviewReportsActionsModal/review-reports-modal.component";
import { AddUpdateAssessmentViolationModule } from "./addUpdateAssessmentViolation/add-update-assessment-violation.module";
export const ReviewReportsPageModule = angular
    .module('4dot5.missioncontrolmodule.reportsmodule.reviewReportsPageModule', [AddUpdateAssessmentViolationModule])
    .component(ReviewReportsActionsModalComponent.selector, ReviewReportsActionsModalComponent.component)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('missioncontrol.reports.reviewReports', {
            url: '/reviewReports',
            component: ReviewReportsPageComponent.selector,
            data: {
                requireLogin: true
            }
        });
    }
])
    .component(ReviewReportsPageComponent.selector, ReviewReportsPageComponent.component)
    .name;
//# sourceMappingURL=review-reports-page.module.js.map